// Cuisine tags for preferences
export const CUISINE_TAGS = [
  'Italian', 'Mexican', 'Asian', 'American', 'Seafood', 'Vegetarian', 'Vegan',
  'Thai', 'Indian', 'Chinese', 'Mediterranean', 'BBQ', 'Fusion', 'Southern', 'Japanese',
  'French', 'Greek', 'Korean', 'Vietnamese', 'Middle Eastern'
] as const;

// Dietary restrictions
export const DIETARY_RESTRICTIONS = [
  'Vegetarian', 'Vegan', 'Gluten-Free', 'Dairy-Free', 'Nut Allergy',
  'Kosher', 'Halal', 'Low-Carb', 'Keto', 'Paleo'
] as const;
